// v1.0 — the original Tweakpane panel. Preserved verbatim (behaviour-wise) so the version switcher
// can show where the tool started: generic auto-generated sliders + per-effect checkboxes + a JSON
// export. No double/halve buttons, no auto-fire — you tuned, then typed a word to test.
//
// Mountable/disposable so the switcher can swap it out for v1.1 and back.

import { Pane } from "tweakpane";
import { feel, DEFAULT_FEEL, type Feel } from "../juice/feel";
import { PARAM_HINTS } from "./scale";

export function mountV1_0(host: HTMLElement): () => void {
  const pane = new Pane({ title: "feel.json — live (v1.0)", container: host });

  pane.addBinding(feel.master, "juice", { label: "MASTER JUICE" });

  for (const [group, cfg] of Object.entries(feel) as [string, any][]) {
    if (group === "master") continue;
    const folder = pane.addFolder({ title: group, expanded: false });
    for (const key of Object.keys(cfg)) {
      const val = cfg[key];
      if (key === "enabled") folder.addBinding(cfg, "enabled", { label: "● on" });
      else if (typeof val === "number")
        folder.addBinding(cfg, key, { ...(PARAM_HINTS[key] ?? {}) });
      else folder.addBinding(cfg, key);
    }
  }

  const tools = pane.addFolder({ title: "⋯ tools", expanded: true });
  tools.addButton({ title: "Export feel.json → console + clipboard" }).on("click", () => {
    const json = JSON.stringify(feel, null, 2);
    console.log(json);
    void navigator.clipboard?.writeText(json).catch(() => {});
  });
  tools.addButton({ title: "Reset to on-disk defaults" }).on("click", () => {
    deepAssign(feel, DEFAULT_FEEL);
    pane.refresh();
  });

  return () => pane.dispose();
}

function deepAssign(dst: any, src: Feel | any): void {
  for (const k of Object.keys(src)) {
    if (src[k] && typeof src[k] === "object") deepAssign(dst[k], src[k]);
    else dst[k] = src[k];
  }
}
